// Import React and button styles
import React from "react";
import "../../../css/buttons/Button.css";
import "../../../css/buttons/TertiaryButton.css";

// TertiaryButton component renders a styled tertiary button with optional text or children
const TertiaryButton = ({ children, onClick, disabled, text }) => {
  return (
    // The button uses conditional classes for disabled state
    <button
      className={`btn btn-tertiary${disabled ? " btn-disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {/* Render the text prop if provided, otherwise render children */}
      <div className="nav"> {text || children} </div>
    </button>
  );
};

// Export the TertiaryButton component for use in other parts of the app
export default TertiaryButton;
